import { render } from "./ClientSearchSection.vue?vue&type=template&id=083470d1"
import script from "./ClientSearchSection.vue?vue&type=script&lang=js"
export * from "./ClientSearchSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__